<template>
  <div class="login-wrap">
    <header-title></header-title>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft26">登录</span>
      </div>
      <el-form status-icon :model="form" :rules="rules" ref="form">
        <el-form-item prop="mobile">
          <el-input v-model="form.mobile" placeholder="账号" auto-complete="on">
            <icon-svg slot="prefix" icon-class="username" />
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="form.password"
            placeholder="密码"
            auto-complete="on"
            @keyup.native.enter="submit('form')"
          >
            <icon-svg slot="prefix" icon-class="password" />
          </el-input>
        </el-form-item>
        <el-form-item class="tr">
          <router-link to="/password-find">
            <span class="blue">忘记密码？</span>
          </router-link>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit('form')" style="width: 100%;">登录</el-button>
        </el-form-item>
      </el-form>
      <el-row class="flex-between" style="margin-top: 30px" v-if="isShowTestBtn">
        <!-- <el-button @click="testLogin(1)">超管登录</el-button> -->
        <!-- <el-button @click="testLogin(1)">快速登录</el-button> -->
        <!-- <el-button @click="testLogin(2)">客服登录</el-button>
        <el-button @click="testLogin(3)">供货商登录</el-button>-->
      </el-row>
    </el-card>
  </div>
</template>

<script>
import HeaderTitle from "@/components/header-title";

import { mapMutations, mapActions } from "vuex";
import loginMixins from "./loginMixins";

export default {
  mixins: [loginMixins],
  components: {
    "header-title": HeaderTitle
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    const validatePwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    return {
      isShowTestBtn: process.env.NODE_ENV === "production" ? false : true,
      form: {
        mobile: "",
        password: ""
      },
      rules: {
        mobile: [{ validator: validateUsername, trigger: "blur" }],
        password: [{ validator: validatePwd, trigger: "blur" }]
      }
    };
  },
  computed: {
    // initLoginBoxHeight() {
    //   const Win_H = window.innerHeight
    //   // header高60 el-main的padding为20
    //   const loginBox_H = `${Win_H}px`
    //   return loginBox_H
    // }
  },
  methods: {
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.login(this.form);
        } else {
          return false;
        }
      });
    },
    ...mapMutations({
      //映射mutation中的方法，映射为this.$store.commit('updateUserInfo');
      //也就是store中方法的简写形式。可通过this.updateUserInfo()方法调用
      updateUserInfo: "updateUserInfo"
    }),
    //快捷登录(仅开发环境可用)
    testLogin(type) {
      let mobile, pwd;
      if (type == 1) {
        mobile = "15225663368";
        pwd = "1234567";
      } else if (type == 2) {
        mobile = "17637545308";
        pwd = "xiaojiao123";
      } else {
        mobile = "15313335938";
        pwd = "yj18798009929";
      }
      this.form.mobile = mobile;
      this.form.password = pwd;
      this.submit("form");
    }
  }
};
</script>

<style lang="less" scoped>
.login-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .box-card {
    width: 400px;
  }
}
</style>
